var swiperHelper;

function swiperHelper(){
	var me = this;
    me.swipers = {};

	me.init = function(offset, swipersJSON){
        me.window = window;
        me.offset = 0;
        if(offset){
            me.offset = offset;
        }

        me.setupSwipers();
        me.initSwipers();
	};

    me.setupSwipers = function(){
        let swiperContainers = document.querySelectorAll('.gz-swiper-container');
        for(let i=0; i<swiperContainers.length; i++){
            let target = swiperContainers[i],
                name = target.dataset.swipername,
                type = target.dataset.swipertype,
                load = target.dataset.swiperload
                callback = target.dataset.swipercallback || false;

            me.swipers[name] = {
                "target": target,
                "type": type,
                "load": load,
				"callback": callback
            };
        }

        me.setSlides();
    };

    me.setSlides = function(){
        for(let name in me.swipers){
            let type = me.swipers[name].type;

            switch(type){
                case "main":
                    me.setMainSlides(name);
                break;

                case "json":
                    me.setJSONSlides(name, me.swipers[name].callback);
                break;

                case "default":
                    me.setDefaultSlides(name);
                break;
            }
        }
    };

    me.setMainSlides = function(name){
        var slidesObj = me.getSlidesFromDOM(name, true);
        var swiper = me.swipers[name];
        swiper["slides"] = slidesObj["slides"];
        swiper["cards"] = slidesObj["cards"];
        swiper["cardsamount"] = parseInt(swiper.target.dataset.swipercardsamount);
        swiper["breakpoint"] = window.matchMedia(swiper.target.dataset.swiperbreakpoint);

        swiper["set"] = function(){
            swiper["breakpoint"].addListener(swiper["breakpointChecker"]);
            swiper.breakpointChecker();
        };
        swiper["breakpointChecker"] = function(){
            me.breakpointChecker(name);
        }
        swiper.set();
    };

    me.setDefaultSlides = function(name){
        me.swipers[name]["slides"] = me.getSlidesFromDOM(name);
    };

    me.getSlidesFromDOM = function(name, extended){
        var slides = [];
        if(extended){
            var slidesObj = {};
            var cards = [];
        }

        let target = me.swipers[name].target;
        let slidesDOM = [].slice.call(target.querySelectorAll(":scope .gz-swiper-slide"));
        for(var i=0; i<slidesDOM.length; i++){
            var slide = slidesDOM[i];
            slides.push(slide.outerHTML);

            if(extended){
                var card = slide.querySelector(':scope > .gz-card');
                cards.push(card);
            }
        }

        if(extended){
            slidesObj["slides"] = slides;
            slidesObj["cards"] = cards;
            return slidesObj;
        } else {
            return slides;
        }
    };

    me.initSwipers = function(){
        for(var name in me.swipers){
            if(me.swipers[name].load == "default"){
                var target = me.swipers[name].target;
                me.swipers[name]["swiper"] = me.initSwiper(target);
                let initSwiperEvent = new CustomEvent('initSwiper', {'detail': {swipername: name}});
                document.dispatchEvent(initSwiperEvent);
            }
        }

        for(var name in me.swipers){
            let swiperIOHandler = (entries) => {
                if (entries[0].isIntersecting) {
                    me.processLazySwiper(entries[0].target, name)
                    swiperIOObserver.unobserve(swiperIOTrigger);
                }
            };
        
            let swiperIOObserver = new window.IntersectionObserver(swiperIOHandler);
            let swiperIOTrigger = me.swipers[name].target;
            if(swiperIOTrigger && me.swipers[name].load == "lazy") {
                swiperIOObserver.observe(swiperIOTrigger);
            }
        }
    };

    me.processLazySwiper = function(target, name){
        if(target && !target.classList.contains('processed')){
            me.swipers[name]["swiper"] = me.initSwiper(target);
            let initSwiperEvent = new CustomEvent('initSwiper', {'detail': {swipername: name}});
            document.dispatchEvent(initSwiperEvent);
            target.classList.add('processed');
        }
    };

    me.breakpointChecker = function(name) {
        var swiper = me.swipers[name];
        if(swiper.swiper === undefined){
            if (swiper.breakpoint.matches === true ){
                if(!swiper.slidesdesktop || swiper.slidesdesktop.length == 0){
                    swiper["slidesdesktop"] = me.generateMainSlides(name);
                }

                var wrapper = swiper.target.querySelector(':scope > .gz-swiper-wrapper');
                while (wrapper.firstChild) {
                    wrapper.removeChild(wrapper.lastChild);
                }

                for(var i=0; i<swiper.slidesdesktop.length; i++){
                    wrapper.appendChild(swiper.slidesdesktop[i]);
                }
            }

            swiper["swiper"] = me.initMainSwiper(swiper.target);
            let initSwiperEvent = new CustomEvent('initSwiper', {'detail': {swipername: name}});
            document.dispatchEvent(initSwiperEvent);
            if (swiper.breakpoint.matches === true ){
                swiper.swiper.autoplay.stop();
                swiper.swiper.update();
            }

			swiper.target.classList.add("gz-swiper-dom-loaded");
        } else {
			swiper.target.classList.remove("gz-swiper-dom-loaded");
			if (swiper.breakpoint.matches === true ){
                if(!swiper.slidesdesktop || swiper.slidesdesktop.length == 0){
                    swiper["slidesdesktop"] = me.generateMainSlides(name);
                }

                swiper.swiper.removeAllSlides();
                swiper.swiper.appendSlide(swiper.slidesdesktop);
				swiper.swiper.autoplay.stop();
                swiper.swiper.update();
            } else {
                swiper.swiper.removeAllSlides();
                swiper.swiper.appendSlide(swiper.slides);
                swiper.swiper.loop = false;
                swiper.swiper.autoplay.start();
                swiper.swiper.update();
            }
            me.updateMainSwiper(swiper.swiper);
			swiper.target.classList.add("gz-swiper-dom-loaded");
        }
    };

    me.generateMainSlides = function(name){
        var swiper = me.swipers[name];
        if(swiper.cardsamount){
            var slidescount = Math.ceil(swiper.cards.length / swiper.cardsamount);
            var structure = new Array(slidescount);

            for(var i = 0, j= 0, k = swiper.cardsamount; i < slidescount; i++){
                structure[i] = swiper.cards.slice(j, k);
                j = k;
                k += swiper.cardsamount;
            }

            return me.generateDOM(structure);
        }
    };

    me.generateDOM = function(structure){
        var slides = [];
        if(structure.length > 0){
            for(var i=0; i<structure.length; i++){
                var slide = document.createElement("div");
                slide.classList.add("swiper-slide");
                slide.classList.add("gz-swiper-slide");

                if(structure[i].length > 0){
                    var cards = [].slice.call(structure[i]);

                    for(var k=0; k<cards.length; k++){
                        slide.appendChild(cards[k]);
                    }
                    slides.push(slide);
                }
            }
            return slides;
        }
    };

    me.initSwiper = function(target, loop) {
        var swiper = new Swiper(target, {
            breakpointsInverse: true,
            navigation: {
                nextEl: target.parentNode.querySelector(':scope .gz-swiper-button-next'),
                prevEl: target.parentNode.querySelector(':scope .gz-swiper-button-prev')
            },
			pagination: {
				el: target.dataset.swiperpagination ? '.gz-swiper-pagination' : null,
				type: 'bullets',
				bulletClass: 'gz-swiper-pagination-bullet',
				bulletActiveClass: 'gz-swiper-pagination-bullet-active'
			},
            loop: target.dataset.swiperloop || false,
            cssMode: target.dataset.swiperloop ? false : true,
            slidesPerView: "auto",
			slidesPerGroup: 1,
            simulateTouch: target.dataset.swiperloop ? true : false,
            breakpoints: {
                1000: {
					slidesPerGroup: target.dataset.swiperslidespergroup
                },
                1200: {
					slidesPerGroup: target.dataset.swiperslidespergroup
                }
            },
            on: {
                slideChange: function() {
                    var direction = (this.activeIndex > this.previousIndex) ? 'rightToLeft' : 'leftToRight';
                }
            }
        });

        return swiper;
    };

    me.initMainSwiper = function(target){
        let cssMode = (device == "desktop") ? false : true;
        let loop = false;
        let nSlides = "auto";
        let slideGap = 0;
        let nextEl = target.parentNode.querySelector(':scope > .gz-swiper-button-next');
        let prevEl = target.parentNode.querySelector(':scope > .gz-swiper-button-prev');

        if(target.dataset.swipername == 'gz-benessererecipes_ben-swiper') {
            nSlides = 1.25;
            slideGap = 10;
            loop = true;
            cssMode = false;
            nextEl = document.querySelector('.gz-swiper-arrows > .gz-swiper-button-next');
            prevEl = document.querySelector('.gz-swiper-arrows > .gz-swiper-button-prev');
        }
        
        if(device == "desktop"){
            if (target.dataset.swiperloop == "true") {
                loop = true;
            } 
        }

        var swiper = new Swiper(target, {
            breakpointsInverse: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			pagination: {
				el: '.gz-swiper-pagination',
				type: 'bullets',
				bulletClass: 'gz-swiper-pagination-bullet',
				bulletActiveClass: 'gz-swiper-pagination-bullet-active'
			},
			navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            loop: loop,
            cssMode: cssMode,
            slidesPerView: nSlides,
            spaceBetween: slideGap,
            updateOnImagesReady: true,
            centeredSlides: true,
            simulateTouch: false,
            breakpoints: {
                1000: {
                    slidesPerView: "auto",
                    spaceBetween: 25
                },
                1200: {
                    slidesPerView: "auto",
                    spaceBetween: 30
                }
            }
        });

        return swiper;
    };

    me.updateMainSwiper = function(swiper){
        swiper.update();
        swiper.slideToLoop(0, 0, false);
    };

    me.setJSONSlides = function(name, callback){
        if(swipersJSON && swipersJSON[name]){
            me.swipers[name]["slides"] = window[callback](name);        
            var target = me.swipers[name].target;
            var wrapper = target.querySelector(':scope > .gz-swiper-wrapper');
            var slides = '';
            for(var i in me.swipers[name].slides){
                slides += me.swipers[name].slides[i];
            }
            
            wrapper.innerHTML = slides;
        }
    };

    me.getSwipers = function(){
		return me.swipers;
	};
    
    me.overrideMainCarouselSlides = function(){
        var slidesObj = me.getSlidesFromDOM("gz-mainrecipes-swiper", true);
        var swiper = me.swipers["gz-mainrecipes-swiper"];
        swiper["cards"] = slidesObj["cards"];
    };
}